module.exports = "/img/user-guided-tours/custom-segments/manage_segments@2x.png?2f7a4326abc98f24fc6d745284fe541c";